define('gigaset_recurring/components/checkout/provider/billwerk/main',[
	"jquery",
	"lodash",
	"cartware/components/_base",
	"lucid",
	"cartware/components/PubSubHub",
	"cartware/jquery/bem",
	"cartware/components/Config",
	"shoptheme/components/tracking",
	"cartware_checkout/classes/accordeon",
	"gigaset_recurring/classes/bridge",
	"gigaset_recurring/classes/checkout/progressbar",
	"gigaset_recurring/classes/checkout/sidebar",
	"gigaset_recurring/classes/provider/billwerk/loader",

	"gigaset_recurring/classes/provider/billwerk/steps/cart",
	"gigaset_recurring/classes/provider/billwerk/steps/cart_dummy",
	"gigaset_recurring/classes/provider/billwerk/steps/address",
	"gigaset_recurring/classes/provider/billwerk/steps/shipping-address",
	"gigaset_recurring/classes/provider/billwerk/steps/shipping-method",
	"gigaset_recurring/classes/provider/billwerk/steps/payment",
	"gigaset_recurring/classes/provider/billwerk/steps/review",

	"text!shoptheme/templates/magnific-popup/default.html",
	"text!shoptheme/templates/customer/address.html",

	"./plugins/addressTypes",

	"magnific-popup"
], function(
	$,
	_,
	Component,
	lucidJS,
	PubSubHub,
	BEM,
	Config,
	Tracking,
	Accordion,
	Bridge,
	Progressbar,
	Sidebar,
	BillwerkLoader,

	CartStep,
	DummyCartStep,
	AddressStep,
	ShippingAddressStep,
	ShippingMethodStep,
	PaymentStep,
	ReviewStep,

	PopupHtml,
	AddressHtml,

	AddressTypesPlugin
) {
	var popupTemplate = null;

	return Component.create(_.create(new lucidJS.EventEmitter, {
		billwerk:			null,
		paymentService:		null,
		signupService:		null,
		priceFormat:		null,
		customer:			null,
		progress:			null,
		accordion:			null,
		checkoutBlock:		null,
		steps:				null,
		previewData:		null,
		quoteToken:			null,

		isBlocked:			false,

		plugins:			null,

		options:			null,

		constructor: function() {
			var self = this;
			lucidJS.EventEmitter.call(this);

			this.plugins = _.map([
				AddressTypesPlugin
			], function(Plugin) {
				return new Plugin(self);
			});
		},

		init: function() {
			this.options = {};
			this.billwerk = {
				initialized:			false,
				pubKey:					Config.get('recurring.provider.billwerk.api.public_key'),
				returnUrl:				Config.get('recurring.provider.billwerk.provider.url.return'),
				createOrderUrl:			Config.get('recurring.provider.billwerk.provider.url.createOrder'),
				validateAddressUrl:		Config.get('recurring.provider.billwerk.provider.url.validateAddress'),
				finalizeAfterUrl:		Config.get('recurring.provider.billwerk.provider.url.finalizeAfter')
			};

			this.saveDataUrl = Config.get('recurring.checkout.url.saveData');
			this.validateQuoteUrl = Config.get('recurring.checkout.url.validateQuote');

			this.quote			= Config.get('recurring.quote');
			this.quoteToken		= Config.get('recurring.quote.token');

			this.priceFormat	= JSON.parse(Config.get('recurring.price.format'));

			this.customer		= Config.get('recurring.customer');
			this.totals			= Config.get('recurring.quote.totals');
			this.plan			= Config.get('recurring.quote.plans.0');

			this.cart			= {
				// "id": Config.get('recurring.order.id')
				"PlanVariantId": _.get(this.plan, 'id'),
				"RatedItems": Config.get('recurring.quote.ratedItems')
				// "RatedItems": [
				// 	{
				// 		"LineItemId": "my-sku-goes-here",
				// 		"Description": "I'm a RatedItem",
				// 		"Quantity": 1,
				// 		"PricePerUnit": 1000,
				// 		"TaxPolicyId": Config.get('recurring.quote.plans.0.tax_policy_id'),
				// 	}
				// ]
				// "componentSubscriptions": [{
				// 	componentId : "59d2395781b1f608ec49ec66",
				// 	quantity : 2
				// }, {
				// 	componentId: "59d26555ba5c2208243ccb2d"
				// }, {
				// 	componentId: "59d2665681b1f608ec49f3ef",
				// 	quantity: 4
				// }]
			};

			this.steps					= [];
			this.previewData			= {};

			BillwerkLoader.once("loaded", _.bind(this.onBillwerkJs, this));
			BillwerkLoader.load();
		},

		$init: function() {
			this.checkoutBlock			= BEM.block("cartware-checkout");
			this.options				= this.checkoutBlock.data('config') || {};

			this.accordion				= new Accordion(this.checkoutBlock);
			this.progress				= new Progressbar("opcheckout-progress-bar");
			this.sidebar				= new Sidebar("opcheckout-progress-sidebar", "checkout-progress");

			this.once("preview.loaded", _.bind(this.initializeSteps, this));
		},

		initializeSteps: function() {
			var steps = {
				"step-cart":				new CartStep,
				"step-cart-dummy":			new DummyCartStep,
				"step-address":				new AddressStep,
				"step-shipping-address":	new ShippingAddressStep,
				"step-shipping-method":		new ShippingMethodStep,
				"step-payment":				new PaymentStep,
				"step-review":				new ReviewStep
			};

			this.emit("hook.initializeSteps.before", steps);

			var i = 0;

			_.forEach(this.options.steps, _.bind(function(id) {
				var step = _.get(steps, id),
					node = this.checkoutBlock.find("#" + id),
					self = this;

				// skip inactive steps
				if (!step || !node.length) {
					return;
				}

				step.setId(id);

				step.addFormData(Config.get('recurring.provider.billwerk.checkout.steps.' + id + '.data', {}));

				if (i) {
					this.steps[i - 1].nextStep = step;
					step.previousStep = this.steps[i - 1];
				}

				var progressStep = this.progress.addStep(node.data("title"));

				step.addData({
					module:			this,
					node:			node,
					title:			node.data("title"),
					progressStep:	progressStep,
					signupService:	this.signupService,
					paymentService:	this.paymentService,
					cart:			this.cart,
					totals:			this.totals,
					customer:		this.customer,
					preview:		this.previewData,
					priceFormat:	this.priceFormat,
					saveDataUrl:	this.saveDataUrl,
					plan:			this.plan,
					quote:			this.quote
				});

				if (step.displayInSidebar()) {
					var sidebarStep = this.sidebar.addStep(step);

					sidebarStep.on("click", function() {
						step.isComplete() && step.open();
					});

					step.on("complete", function() {
						sidebarStep.setComplete();
					});

					step.on("incomplete", function() {
						sidebarStep.setComplete(false);
					});
				}

				progressStep.on("click", function() {
					step.isComplete() && step.open();
				});

				step.on("active", function(data) {
					self.logger.debug("step active", step);
					step.getData("progressStep").setActive();
					self.accordion.openSection(step.getId(), {
						immediately: _.get(data, "immediately")
					});
					self.sidebar[step.shouldDisplaySidebar() ? "show" : "hide"]();
				});

				step.on("inactive", function() {
					self.logger.debug("step inactive", step);
					step.getData("progressStep").setActive(false);
				});

				step.on("complete", function() {
					self.logger.debug("step complete", step);
					step.getData("progressStep").setComplete();
				});

				step.on("incomplete", function() {
					self.logger.debug("step incomplete", step);
					step.getData("progressStep").setComplete(false);
				});

				step.on("layout", function() {
					self.logger.debug("step layout", step);
					self.accordion._layout();
				});

				step.on("requestPreview", function() {
					self.logger.debug("step request preview", step);
					self.reloadPreview();
				});

				step.on("updateQuote", function(quote) {
					self.updateQuote(quote);
					self.emit("updateQuote", quote);
				});

				step.on("updateBlocks", function(blocks) {
					self.emit("updateBlocks", blocks);
				});

				step.on("validationError", function(message) {
					self.displayValidationError(message);
				});

				step.on("close", function() {
					self.logger.debug("step close", step);
					_.defer(self.accordion._layout);
				});

				step.on("next", function() {
					self.logger.debug("step next", step);
					if (self.steps.indexOf(step) === self.steps.length - 1) {
						self.createOrder(
							_.clone(step.getFormData("cart")),
							_.clone(step.getFormData("customer")),
							_.clone(step.getFormData("payment")),
							_.clone(step.getFormData("address"))
						);

						// self.pay(
						// 	{
						// 		'ContractId':	Config.get('recurring.order.ContractId'),
						// 		'Currency':		Config.get('recurring.order.Currency'),
						// 		'CustomerId':	Config.get('recurring.order.CustomerId'),
						// 		'GrossTotal':	Config.get('recurring.order.TotalGross'),
						// 		'OrderId':		Config.get('recurring.order.Id')
						// 	},
						// 	_.clone(step.getFormData("payment"))
						// );
					}
				});

				step.on("error", function(e, message) {
					self.handleError(e, message);
				});

				step.initialize();

				this.steps.push(step);
				i++;
			}, this));

			this.steps[0].open();
		},

		getStepById: function(id) {
			return _.find(this.steps, function(step) {
				return step.getId() === id;
			});
		},

		updateQuote: function(quote) {
			var reloadPreview = false;
			var ratedItems = _.get(quote, 'ratedItems');
			var totals = _.get(quote, 'totals');

			if (ratedItems) {
				this.cart.RatedItems = ratedItems;
				reloadPreview = true;
			}

			if (totals) {
				this.totals = totals;
				_.forEach(this.steps, function(step) {
					step.addData({totals: totals});
				});
			}

			reloadPreview && this.reloadPreview();
		},

		createOrder: function(cart, customer, paymentData, address) {
			var data = {
				cart:		cart,
				customer:	customer,
				address:	address,
				token:		this.quoteToken
			};

			if (this.isBlocked) return;

			this.logger.debug("create order", data);
			this.emit("order.create");
			this.isBlocked = true;

			$.post(this.billwerk.createOrderUrl, data)
				.always(_.bind(function() {
					this.isBlocked = false;
				}, this))
				.done(_.bind(function(data) {
					this.logger.debug("successfully created order", data);
					this.pay(data.order, paymentData);
				}, this))
				.fail(_.bind(function(xhr) {
					var errorData = xhr.responseJSON || {};
					this.emit("order.fail");
					this.logger.error("error creating order", errorData);
					this.handleError(errorData);
				}, this));


			// this.signupService.createOrder(cart, customer,
			// 	_.bind(function(order) {
			// 		this.pay(order, paymentData);
			// 	}, this),
			// 	function() {
			// 		console.log("ERROR", arguments);
			// 	}
			// );
		},

		pay: function(order, paymentData) {
			this.logger.debug("pay", arguments);
			// this.logger.debug("my order", Config.get('recurring.order'));
			// return;
			// paymentData.bearer = "__invalid__";

			this.emit("payment.signup");

			try {
				this.signupService.paySignupInteractive(this.paymentService, paymentData, order,
					_.bind(this.handlePayment, this),
					_.curryRight(
						_.bind(this.handleError, this),
						this.translate("An error occurred when connecting to the payment service")
					)
				);
			} catch (e) {
				this.emit("payment.fail");
				this.handleError(e);
			}
		},

		handlePayment: function(result) {
			this.emit("payment.complete");
			this.emit("order.complete");

			this.logger.debug("handle payment", result);

			if (!result.Url) {
				if (result.ContractId) {
					$.post(this.billwerk.finalizeAfterUrl, { contractId: result.ContractId })
						// call to finalizeAfter should not be a hard dependency
						// the contract has already been created and charged by that time
						.always(_.bind(this.handleOrderComplete, this))
						.fail(_.bind(function(xhr) {
							this.logger.error("Error saving contract data to order");
						}, this));
				}
			} else {
				window.location.href = result.Url;
			}
		},

		handleOrderComplete: function(result) {
			result = _.get(result, 'responseJSON', result);
			this.logger.debug("order complete", arguments);
			Bridge.orderComplete(result);
		},

		// todo
		handleOrderFailed: function(message) {
			result = _.get(result, 'responseJSON', result);
			this.logger.error("order failed", message);
			Bridge.orderFailed(message);
		},

		onBillwerkInitialized: function() {
			this.billwerk.initialized = true;

			this.signupService.preview(this.cart, this.customer, _.bind(function(data) {
				this.previewData = data;
				this.flag("preview.loaded", data);
			}, this), function() {
				this.handleError(new Error('Failed loading preview'))
			});
		},

		onBillwerkInitializationFail: function() {
			this.billwerk.initialized = false;
		},

		onBillwerkJs: function() {
			this.signupService = new BillwerkJS.Signup();
			this.paymentService = new BillwerkJS.Payment({
					publicApiKey : this.billwerk.pubKey,
					providerReturnUrl : this.billwerk.returnUrl
				},
				_.bind(this.onBillwerkInitialized, this),
				_.bind(this.onBillwerkInitializationFail, this)
			);
		},

		reloadPreview: function() {
			this.logger.debug("reload preview", this.cart);

			this.signupService.preview(this.cart, this.customer, _.bind(function(data) {
				_.assign(this.previewData, data);
				this.emit("preview.reloaded", data);
			}, this), function() {
				this.handleError(new Error('Failed loading preview'))
			});
		},

		handleError: function(error, customMessage) {
			var message = "undefined" !== typeof customMessage
				? customMessage
				: _.get(error, "message", this.translate("Unknown error"));

			var errorCodes = _.get(error, "errorCode", null),
				handled = false;

			this.logger.debug("handleError", error, customMessage);

			if (_.isArray(errorCodes)) {
				_.forEach(errorCodes, _.bind(function(code) {
					var errorHandler = _.get(this, ["errorHandlers", code]),
						result;

					if (!errorHandler) return;

					this.logger.debug("Calling error handler", code);

					result = _.attempt(_.bind(errorHandler, this), error);

					if (!handled) {
						handled = !_.isError(result);
					}
				}, this));
			}

			if (!handled) {
				this.openModal(message, this.translate("Validation error"));
				this.logger.trace(message, error);
			}
		},

		translate: function(string) {
			return _.isFunction(window.Translator.translate) ? window.Translator.translate(string) : string;
		},

		displayValidationError: function(message) {
			this.openModal(this.translate(message), this.translate("Validation error"));
		},

		openModal: function(body, title, footer) {
			var module = this;
			var defaultModalFooterHtml = '<div class="b_validation-result__buttons">' +
				'<button class="btn btn-primary b_validation-result__button b_validation-result__button--accept" data-mfp-close>' +
				this.translate("OK") +
				'</button>' +
				'</div>';
			var defaultModalFooter = _.template(defaultModalFooterHtml);
			title = (typeof title === "undefined") ? '' : title;
			footer = (typeof footer === "undefined") ? defaultModalFooter({}) : footer;

			$.magnificPopup.open({
				items: {
					src: this._renderPopup({ body: body, title: title, footer: footer }),
					type: 'inline'
				},
				callbacks: {
					open: function () {
						var self = this;
						this.content.on("click", "[data-mfp-close]", function () {
							self.close();
						});
						module.emit("modal.open", this);
					},
					close: function() {
						module.emit("modal.close", this);
					}
				}
			});
		},

		_renderPopup: function(data) {
			if (null === popupTemplate) {
				popupTemplate = _.template(PopupHtml);
			}

			return popupTemplate(data);
		},

		errorHandlers: {
			__default__: function(error, message, stepId, title) {
				message = message || "Unknown error";
				title = title || "";

				this.logger.error(message, error);
				this.openModal(this.translate(message), this.translate(title));

				stepId && this.getStepById(stepId).open();

				return true;
			},

			QAddressValidationError: function(error) {
				var qAddress = _.get(error, "qaddress", null);
				var message = _.get(error, "message", '');
				message = this.translate(message);

				if (qAddress !== null) {
					var messageAddressHtml = '<div class="b_qaddress-validation-result">' +
						'<p class="b_qaddress-validation-result__message<% if (address) { %> b_qaddress-validation-result__message--with-line<% } %>">' +
						'<%= message %>' +
						'</p>' +
						'<%= address %>';
					var messageAddressTemplate = _.template(messageAddressHtml);
					var addressTemplate = _.template(AddressHtml);

					message = messageAddressTemplate({message: message, address: addressTemplate(qAddress)});
				}
				this.openModal(message, this.translate("Address validation"));

				return true;
			},

			AddressValidationError: function(error) {
				var message = _.get(error, "errorMessage", '');
				this.openModal(message, this.translate("Address validation"));

				return true;
			},

			IteroServerError: function(error) {
				return this.errorHandlers.__default__.call(
					this,
					error,
					"There has been an error processing your request at the recurring service provider"
				);
			},

			PspServerError: function(error) {
				return this.errorHandlers.__default__.call(
					this,
					error,
					"There has been an error processing your request at the payment service provider",
					"step-payment"
				);
			},

			Timeout: function(error) {
				return this.errorHandlers.__default__.call(
					this,
					error,
					"A timeout occurred while processing your request"
				);
			},

			InvalidKey: function(error) {
				return this.errorHandlers.__default__.call(
					this,
					error,
					"An internal error occurred (invalid key)"
				);
			},

			InvalidConfiguration: function(error) {
				return this.errorHandlers.__default__.call(
					this,
					error,
					"An internal error occurred (invalid configuration)"
				);
			},

			InvalidPaymentData: function(error) {
				return this.errorHandlers.__default__.call(
					this,
					error,
					"An internal error occurred (invalid payment data)"
				);
			},

			InvalidData: function(error) {
				return this.errorHandlers.__default__.call(
					this,
					error,
					"An internal error occurred (invalid data)"
				);
			},

			UnmappedError: function(error) {
				return this.errorHandlers.__default__.call(
					this,
					error,
					"An unknown error occurred (unmapped error)"
				);
			},

			Aborted: function(error) {
				return this.errorHandlers.__default__.call(
					this,
					error,
					"Your request has been aborted"
				);
			},

			AcquirerServerError: function(error) {
				return this.errorHandlers.__default__.call(
					this,
					error,
					"There has been an error processing your request at the acquirer"
				);
			},

			AuthorizationRejected: function(error) {
				return this.errorHandlers.__default__.call(
					this,
					error,
					"The authorization has been rejected",
					"step-payment"
				);
			},

			RateLimit: function(error) {
				return this.errorHandlers.__default__.call(
					this,
					error,
					"The network is currently under heavy load. Please try again later",
					"step-cart"
				);
			},

			InvalidTransaction: function(error) {
				return this.errorHandlers.__default__.call(
					this,
					error,
					"An internal error occurred (invalid transaction)",
					"step-cart"
				);
			},

			AmountLimitExceeeded: function(error) {
				return this.errorHandlers.__default__.call(
					this,
					error,
					"The amount limit has been exceeded",
					"step-cart"
				);
			},
			AmountLimitExceeded: function(error) {
				return this.errorHandlers.AmountLimitExceeeded.call(this, error);
			},

			InvalidPaymentMethod: function(error) {
				return this.errorHandlers.__default__.call(
					this,
					error,
					"The given payment method is invalid",
					"step-payment"
				);
			},

			InvalidCardType: function(error) {
				return this.errorHandlers.__default__.call(
					this,
					error,
					"The given card type is invalid",
					"step-payment"
				);
			},

			InvalidCardNumber: function(error) {
				return this.errorHandlers.__default__.call(
					this,
					error,
					"The given card number is invalid",
					"step-payment"
				);
			},

			InvalidExpirationDate: function(error) {
				return this.errorHandlers.__default__.call(
					this,
					error,
					"The given expiration date is invalid",
					"step-payment"
				);
			},

			InvalidCardCvc: function(error) {
				return this.errorHandlers.__default__.call(
					this,
					error,
					"The given card cvc is invalid",
					"step-payment"
				);
			},

			InvalidCardHolder: function(error) {
				return this.errorHandlers.__default__.call(
					this,
					error,
					"The given card holder is invalid",
					"step-payment"
				);
			},

			"3DsProblem": function(error) {
				return this.errorHandlers.__default__.call(
					this,
					error,
					"A error occurred while validating 3-D secure data",
					"step-payment"
				);
			},

			InvalidAmount: function(error) {
				return this.errorHandlers.__default__.call(
					this,
					error,
					"An internal error occurred (invalid amount)"
				);
			},

			InvalidCurrency: function(error) {
				return this.errorHandlers.__default__.call(
					this,
					error,
					"An internal error occurred (invalid currency)"
				);
			},

			InvalidAccountNumber: function(error) {
				return this.errorHandlers.__default__.call(
					this,
					error,
					"The given account number is invalid",
					"step-payment"
				);
			},

			InvalidAccountHolder: function(error) {
				return this.errorHandlers.__default__.call(
					this,
					error,
					"The given account holder is invalid",
					"step-payment"
				);
			},

			InvalidBankCode: function(error) {
				return this.errorHandlers.__default__.call(
					this,
					error,
					"The given bank code is invalid",
					"step-payment"
				);
			},

			InvalidIban: function(error) {
				return this.errorHandlers.__default__.call(
					this,
					error,
					"The given IBAN is invalid",
					"step-payment"
				);
			},

			InvalidBic: function(error) {
				return this.errorHandlers.__default__.call(
					this,
					error,
					"The given BIC is invalid",
					"step-payment"
				);
			},

			InvalidCountry: function(error) {
				return this.errorHandlers.__default__.call(
					this,
					error,
					"An internal error occurred (invalid country)"
				);
			},

			BearerRejected: function(error) {
				return this.errorHandlers.__default__.call(
					this,
					error,
					"The given payment data has been rejected",
					"step-payment"
				);
			},

			BearerExpired: function(error) {
				return this.errorHandlers.__default__.call(
					this,
					error,
					"The given payment data has expired",
					"step-payment"
				);
			},

			InvalidCouponCode: function(error) {
				return this.errorHandlers.__default__.call(
					this,
					error,
					"The given coupon code is invalid",
					"step-cart"
				);
			}
		}
	}));
});
